module.exports = __webpack_public_path__ + "img/user-pic.d05eab98.png";